<app-ice-card>
  <div class="new-mobile-phone-details">
    @if (isManualRegistration) {
      <app-mobilephone-gtin-scan (gtinScanned)="onGtinScanned($event)" />
    }
    @if (!isManualRegistration) {
      <app-mobilephone-variant-options
        [mobilePhoneGroupVariants]="mobilePhoneGroupVariants"
        [selectedVariant]="selectedVariant"
        (variantChanged)="onVariantChanged($event)"
      />
    }
    @if (isLoadingMobilePhoneOffering) {
      <app-spinner />
    } @else {
      @if (mobilePhoneVariant) {
        <app-mobilephone-payment-details
          [allVoiceProducts]="existingVoiceProducts"
          [existingProductsAvailableForEquipmentUpgrade]="existingProductsAvailableForEquipmentUpgradeUpgrade"
          [hasMobilBytteProductInCart]="false"
          [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled"
          [isEquipmentUpgradePreCheckSuccessful]="isEquipmentUpgradePreCheckSuccessful"
          [isManualRegistration]="isManualRegistration"
          [isMobilBytteBytte]="true"
          [mobilePhoneVariant]="mobilePhoneVariant"
          (equipmentUpgradeNewOfferingChanged)="onEquipmentUpgradeNewOfferingChanged($event)"
        />
        @if (newMobileForm.get(MobilePhoneFormControls.IsSubscriptionUpgrade).enabled) {
          <app-equipment-voice-number-type
            [existingProductsAvailableForEquipmentUpgrade]="existingProductsAvailableForEquipmentUpgradeUpgrade"
            [existingVoiceProducts]="existingVoiceProducts"
            [isSubscriptionLimitReached]="isSubscriptionLimitReached"
            (getExistingVoiceProductsDetails)="onGetExistingVoiceProductsDetails()"
          />
        }
        @if (canSellMobileInsurance()) {
          <app-mobilephone-insurance-options
            [allVoiceProducts]="allVoiceProducts()"
            [mobilePhoneVariant]="mobilePhoneVariant"
          />
        }
        @if (newMobileForm.get(MobilePhoneFormControls.IsSoldInShop).enabled && !isManualRegistration) {
          <app-mobilephone-delivery-type
            [canSellHardwareWithLogistics]="canSellHardwareWithLogisticsClaim"
            [mobilePaymentType]="newMobileForm.get(MobilePhoneFormControls.PaymentType)?.value"
          />
        }
        <div class="buttons">
          @if (!isManualRegistration) {
            <div>
              <app-ice-button
                color="secondary"
                testId="pick-different-phone-button"
                width="100%"
                (click)="backToSearch.emit()"
              >
                Velg en annen telefon
              </app-ice-button>
            </div>
          }
          <div>
            <app-ice-button
              color="primary"
              testId="mobile-phone-continue-button"
              width="100%"
              [disabled]="newMobileForm.invalid"
              (click)="onSubmit()"
            >
              Fortsett
            </app-ice-button>
          </div>
        </div>
      }
    }
  </div>
</app-ice-card>
